import { L } from '@lib';
import { Row, Typography } from 'antd';
import React from 'react';
import QRCode from 'react-qr-code';
import styled from 'styled-components';

const StyledQrTemplate = styled.div`
  background: #0073A9;
  padding: 1vw;
`
const StyledQrHolderTemplate = styled.div`
  padding: 15px;
  background-color: white;
  display: flex;
`

const { Title } = Typography;

interface IProps {
  value: string;
}

export const QRCodeGenerator: React.FC<IProps> = ({ value }) => {
  return (
    <StyledQrTemplate>
      <Row justify="center">
        <Title style={{ color: 'white' }} level={3}>
          {L('SCAN ME')}
        </Title>
      </Row>
      <StyledQrHolderTemplate>
        <QRCode
          size={128}
          style={{ height: 'auto', maxWidth: '100%', width: '100%' }}
          value={value}
          viewBox={`0 0 256 256`}
        />
      </StyledQrHolderTemplate>
    </StyledQrTemplate>
  );
};
